import React, { useEffect, useState, useMemo } from 'react';
import PropTypes from 'prop-types';
import Select from './Select';

function PhoneInput({
  id,
  type,
  inputClassName,
  placeholder,
  name,
  value,
  onChange,
  disabled,
  inputProps,
  countries = [],
  onCountrySelection,
}) {
  const [selectedCountry, setSelectedCountry] = useState({
    phone: '',
    country: '',
  });

  const countryOptions = useMemo(
    () =>
      countries.map(c => ({
        id: c.code,
        text: `${c.flagEmoji} (+${c.phone})`,
      })),
    [countries],
  );

  useEffect(() => {
    if (countries.length > 0) {
      const userLocale = navigator.language;
      const countryCode = userLocale.split('-')[1];
      const defaultCountry =
        countries.find(c => c.code === countryCode) || countries[0];

      setSelectedCountry({
        phone: `${defaultCountry.phone} `,
        country: defaultCountry.code,
      });
    }
  }, [countries]);

  const handleCountryChange = newValue => {
    const newCountry = countries.find(c => c.code === newValue);
    if (newCountry) {
      setSelectedCountry({ phone: `${newCountry.phone} `, country: newValue });
    }
    onCountrySelection(newCountry);
  };

  return (
    <div className="phone-input-container">
      {countries.length > 0 && (
        <Select
          onChange={handleCountryChange}
          id={`select-${id}`}
          items={countryOptions}
          value={selectedCountry.country}
          className="phone-selector"
        />
      )}
      <input
        className={`form-control m-input phone-input ${inputClassName}`}
        id={id}
        type={type}
        placeholder={placeholder}
        name={name}
        value={value}
        onChange={e => onChange && onChange(e.currentTarget.value)}
        readOnly={!onChange}
        disabled={disabled}
        {...inputProps}
      />
    </div>
  );
}

PhoneInput.propTypes = {
  inputClassName: PropTypes.string,
  id: PropTypes.string,
  name: PropTypes.string,
  type: PropTypes.string,
  value: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
    PropTypes.array,
  ]),
  onChange: PropTypes.func,
  placeholder: PropTypes.string,
  disabled: PropTypes.bool,
  inputProps: PropTypes.shape({}),
  countries: PropTypes.arrayOf(
    PropTypes.shape({
      code: PropTypes.string.isRequired,
      phone: PropTypes.string.isRequired,
      flagEmoji: PropTypes.string.isRequired,
    }),
  ),
  onCountrySelection: PropTypes.func,
};

PhoneInput.defaultProps = {
  inputClassName: '',
  id: undefined,
  name: undefined,
  type: 'text',
  value: '',
  onChange: undefined,
  placeholder: '',
  disabled: false,
  inputProps: {},
  countries: [],
  onCountrySelection: undefined,
};

export default PhoneInput;
